package org.multiplatform.kotfolio.pages.listing

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.WebImage
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import org.multiplatform.kotfolio.util.Resources

@Page("paneer_press_maker")
@Composable
fun PaneerPressMakerListing() {
    BlogLayout(
        PageProperties(
            "Paneer Press Maker",
            ""
        ),
        BlogProperties("Listing", "Paneer Press Maker - (Square Shape, Round Shape)")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            WebImage(
                src = Resources.Images.PANNER_PRESS_MAKER_PRODUCT,
                modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                contentDescription = "Panner Press Maker"
            )

            SpanText(
                text = "Title",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tofu Making",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Homemade Paneer Make",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Paneer Making",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Curd Pressing",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cheese Making",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Whey Draining",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Kitchen Prep",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Description",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "✅ STAINLESS STEEL DURABILITY – Made from premium food-grade stainless steel, rust-resistant, strong and long-lasting for daily kitchen use.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "✅ PERFECT HOMEMADE PANEER & TOFU – Square 350ml mould ensures evenly pressed paneer or tofu with smooth texture and consistent shape every time.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "✅ WHEY SEPARATOR & LID INCLUDED – Built-in whey separator with fitted lid allows easy pressing and draining, ideal for fresh paneer, tofu and cheese.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "✅ MEDIUM SIZE & VERSATILE DESIGN – 350ml capacity with compact square shape, suitable for daily cooking, small to medium families and homemade dairy products.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "✅ EASY TO USE & EASY TO CLEAN – Smooth stainless steel surface prevents sticking; dishwasher-safe and effortless to clean after use.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "✅ CAPACITY: 450ml – perfect for 200–250g paneer per batch.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "✅ MATERIAL: High-quality food-grade stainless steel for safety and hygiene.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "✅ DESIGN: Square press ensures uniform shaping and even water drainage.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Description",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Create delicious, fresh, and hygienic paneer at home with the Stainless Steel Square Paneer Maker. Designed with convenience and efficiency in mind, this premium quality paneer mould is made from durable food-grade stainless steel. The compact square shape ensures perfect paneer consistency, making it easy to prepare firm and sliced paneer for all your culinary needs. The removable base and top press lid make the straining process hassle-free, allowing you to enjoy homemade paneer with minimal effort.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This paneer maker with press lid supports easy draining of excess water and ensures a clean, smooth texture for your paneer. Ideal for home cooks and paneer enthusiasts, the product's sturdy structure guarantees long-lasting use. Whether you're making soft paneer for curries or firm paneer for grilling, this mould offers the flexibility and control to meet your requirements. Simple to clean and maintain, this practical kitchen tool is an essential for any kitchen.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Make Fresh, Firm Paneer at Home with this simple and efficient paneer maker! Enjoy freshly made paneer in your favorite dishes anytime you like!",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }
        }
    }
}

//https://nyrakitchenware.in
//https://krafthouseware.com

//https://www.amazon.in/Paneer-Maker-Stainless-Homemade-Cheese/dp/B0GWVH5VWD?th=1
//https://www.amazon.in/Crockett-Stainless-Steel-Paneer-Press/dp/B0FRXSJ1H4
//https://www.amazon.in/Expresso-Stainless-Square-Indian-Paneer/dp/B0BVMRBSSP/ref=pd_day0_d_sccl_2_3/523-2277569-9125659?pd_rd_w=YZxyW&content-id=amzn1.sym.0640b4dc-6d30-422d-bb8f-d11de15b1b49&pf_rd_p=0640b4dc-6d30-422d-bb8f-d11de15b1b49&pf_rd_r=PG188PCJPW2GFSVEBGD4&pd_rd_wg=WQmWH&pd_rd_r=d39119c6-7c72-4108-afc9-5f83c2e4c3f6&pd_rd_i=B0BVMRBSSP&th=1